// extracted by mini-css-extract-plugin
export var chevron = "_al-2";
export var dropdownItems = "_al-0";
export var item = "_al-1";